const lowlights = ['LowFill1', 'LowFill2', 'LowFill3', 'LowFill4', 'LowFill5', 'LowFill6', 'LowFill7', 'LowFill8', 'LowFill9', 'LowFill10', 'LowFill5'];
const highlights = ['HighFill1', 'HighFill2', 'HighFill3', 'HighFill4', 'HighFill5', 'HighFill6', 'HighFill7', 'HighFill8', 'HighFill9', 'HighFill10', 'HighFill5'];
const hoverlights = ['HoverFill1', 'HoverFill2', 'HoverFill3', 'HoverFill4', 'HoverFill5', 'HoverFill6', 'HoverFill7', 'HoverFill8', 'HoverFill9', 'HoverFill10', 'HoverFill11'];

const selections = [[11], [5, 8], [5, 8, 10], [2, 5, 8, 10], [1, 3, 5, 8, 10], [1, 2, 3, 4, 5, 6], [1, 2, 3, 4, 5, 6, 7], [1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]];

export type ColorType = 'LowLight' | 'Highlight' | 'hover';

export const GetClasses = (num: number, colorType: ColorType, reverse: boolean = false): string[] => {
    const ret = new Array<string>();
    const selection = selections[num - 1];
    if (reverse) {
        for (let i = selection.length-1; i >= 0; i--) {
            ret.push(colorType === 'LowLight' ? lowlights[selection[i] - 1] : (colorType === 'Highlight' ? highlights[selection[i] - 1] : hoverlights[selection[i] - 1]));

        }

    }
    else {
        for (let i = 0; i < selection.length; i++) {
            ret.push(colorType === 'LowLight' ? lowlights[selection[i] - 1] : (colorType === 'Highlight' ? highlights[selection[i] - 1] : hoverlights[selection[i] - 1]));

        }
    }
    return ret;
}
